import React from "react";
import "./authlayout.scss";
import { Outlet } from "react-router-dom";
import logoWithName from "../../../assets/images/logo/newLogo.png";

function AuthLayout() {
  return (
    <div className="authlayout-container">
      <div className="page-details">
        <div className="logo-img-container">
          <img src={logoWithName} alt="logo" />
        </div>
        <h1 className="page-title">
          Capture. Showcase. Impress. Earn.
        </h1>
        <h4 className="page-sub-title">
         Join Aerial Borne and start earning from your passion today.
        </h4>
      </div>
      
      <div className="authContainer">
      <div className="auth-logo">
          <img src={logoWithName} alt="logo" />
        </div>
        <Outlet />
      </div>
    </div>
  );
}

export default AuthLayout;
